import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GuestData } from 'types';

export type GuestStore = {
  isLoading: boolean;
  errorMsg: string;
  guest: GuestData | null;
  isOpenGuestModal: boolean;
};

const initialState: GuestStore = {
  errorMsg: '',
  guest: null,
  isLoading: false,
  isOpenGuestModal: false
};

export const guestSlice = createSlice({
  name: 'guest',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    clearErrors: (state) => {
      state.errorMsg = '';
    },
    setGuestData: (state, action: PayloadAction<GuestData | null>) => {
      state.guest = action.payload;
    },
    openGuestModal: (state) => {
      state.isOpenGuestModal = true;
    },
    closeGuestModal: (state) => {
      state.isOpenGuestModal = false;
    },
    guestSessionFinished: (state) => {
      state.guest = null;
      state.errorMsg = '';
      state.isLoading = false;
    }
  }
});

export const {
  setError,
  setIsLoading,
  clearErrors,
  setGuestData,
  openGuestModal,
  closeGuestModal,
  guestSessionFinished
} = guestSlice.actions;

export default guestSlice.reducer;
